<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.END_SESSION') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-datetime-picker
          ref="dateTimePicker"
          v-model="endTime"
          :label="$vuetify.lang.t('$vuetify.END_TIME')"
          date-format="dd-MM-yyyy"
          :text-field-props="{ outlined: true, hideDetails: true }"
          time-format="HH:mm"
          :date-picker-props="{ firstDayOfWeek: 1 }"
          :time-picker-props="{ format: '24hr' }"
        >
          <template v-slot:dateIcon>
            <v-icon>mdi-calendar-outline</v-icon>
          </template>
          <template v-slot:timeIcon>
            <v-icon>mdi-clock-outline</v-icon>
          </template>
          <template slot="actions" slot-scope="{ parent }">
            <v-btn color="accent" text @click.native="onCancelClick()">
              {{ $vuetify.lang.t('$vuetify.CANCEL') }}
            </v-btn>
            <v-btn color="primary" class="secondary--text" @click="parent.okHandler">OK</v-btn>
          </template>
        </v-datetime-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CANCEL') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="
            loading.state && loading.type === 'postPrivilegedEndParkingSession'
          "
          @click="saveSession()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EndSessionDialog',
  props: {
    session: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      endTimePicker: false,
      endTime: ''
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.endTime = new Date()
  },
  methods: {
    ...mapActions('sessions', ['postPrivilegedEndParkingSession']),
    async saveSession() {
      await this.postPrivilegedEndParkingSession({
        ParkingSessionId: this.session.Id,
        EndTime: this.endTime
      })
      this.show = false
    },
    onCancelClick() {
      this.$refs.dateTimePicker.okHandler()
      this.endTime = new Date()
    }
  }
}
</script>
